import { lazyLoad } from 'utils/loadable';

export const GuaranteeProgramDetailPage = lazyLoad(
  () => import('./index'),
  module => module.GuaranteeProgramDetailPage,
);
